import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "../../../../api/agent";
import { AppResponse } from "../../../../models/app/AppResponse";
import { Order } from "../../../../models/features/Order/Order";
import { OrderFilter } from "../../../../models/app/AppModels";

export const orderApi = createApi({
  reducerPath: "orderApi",
  baseQuery: axiosBaseQuery(),

  endpoints: (build) => ({
    getOrders: build.query<AppResponse<Order>, { paging: OrderFilter }>({
      query: ({ paging }) => ({
        url: `api/Order/GetOrders`,
        method: "post",
        data: paging,
      }),
    }),
    getOrderStatus: build.mutation<any, { orderId: string }>({
      query: ({ orderId }) => ({
        url: `api/Order/GetOrderStatus?orderId=${orderId}`,
        method: "post",
        data: null,
      }),
    }),
    deleteOrder: build.mutation<any, { orderId: string }>({
      query: ({ orderId }) => ({
        url: `api/Order/DeleteOrder?orderId=${orderId}`,
        method: "post",
        data: null,
      }),
    }),
    markOrdersAsRead: build.mutation<any, void>({
      query: () => ({
        url: `api/Order/MarkOrdersAsRead`,
        method: "put",
        data: null,
      }),
    }),
    resyncOrder: build.mutation<any, { orderId: string; setupId: string }>({
      query: (data) => ({
        url: `api/Order/ResyncOrder`,
        method: "post",
        data: data,
      }),
    }),
  }),
});

export const {
  useGetOrdersQuery,
  useGetOrderStatusMutation,
  useDeleteOrderMutation,
  useMarkOrdersAsReadMutation,
  useResyncOrderMutation,
} = orderApi;
export const orderReducer = orderApi.reducer;
